import 'bootstrap-loader';
import moment from 'moment';
require('moment-duration-format');
require('./sass/main.sass');
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';
import { buttonLoading, showModal } from './modules/modals';
import { guessTz } from './modules/timezoneGuess';
import { inputFocusStyleFix } from './modules/forms';
import { initRememberedAlerts } from './modules/alerts';
import { initDataDogLogs } from './app/errors/dataDog';

initDataDogLogs({
  serviceName: 'engage-legacy-frontend',
  version: process.env.LEGACY_FRONTEND_RELEASE_VERSION
});

var timerInterval = null;

if (typeof sentry_frontend_dsn !== 'undefined') {
  let options = {};
  options['dsn'] = sentry_frontend_dsn;
  if (typeof sentry_environment !== 'undefined') {
    options['environment'] = sentry_environment;
  }

  if (typeof sentry_release !== 'undefined') {
    options['release'] = sentry_release;
  }

  Sentry.init(options);
  window.Sentry = Sentry;
}

// Boostrap disabled button-group fix
$('.btn-group .btn.disabled').click(function (event) {
  event.stopPropagation();
});

var timer;

function updateCountdown(startTime) {
  const now = new Date();
  if (now <= startTime) {
    const startsIn = moment.duration(moment(startTime).diff(now)).format();
    document.getElementById('alert-starts-soon-countdown').textContent = startsIn;
  } else {
    clearInterval(timer);
    document.getElementById('alert-starts-soon').style.display = 'none';
    document.getElementById('alert-in-progress').style.display = '';
  }
}

function startCountDown() {
  if (typeof startTimeISO !== 'undefined') {
    const startTime = new Date(Date.parse(startTimeISO));

    updateCountdown(startTime);

    if (new Date() <= startTime) {
      timer = setInterval(function () {
        updateCountdown(startTime);
      }, 1000);
    }
  }
}

startCountDown();

function simplePost(action) {
  var form = $('<form/>', {
    action: action,
    method: 'POST'
  });
  form.append(
    $('<input/>', {
      type: 'hidden',
      name: 'csrfmiddlewaretoken',
      value: Cookies.get('csrftoken')
    })
  );
  form.appendTo('body').submit();
}

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
  $(document).off('.dropdown.data-api');
  $('[data-toggle="dropdown"]').dropdown();
});

$(document).on('click', 'a[data-post]', function () {
  simplePost($(this).attr('href'));
  return false;
});

function connectWs(currentReconnectDelay) {
  const socket = new WebSocket(ws_personal_url);
  socket.onopen = function (e) {
    setInterval(function () {
      if (socket.readyState == 1) {
        socket.send('ping');
      }
    }, 600000); // 10 minutes
  };
  socket.onmessage = function (e) {
    const data = JSON.parse(e.data);
    if (data.event && data.event === 'session_starts_soon') {
      if (data.selector && data.url) {
        $(data.selector).load(data.url, function () {
          startCountDown();
        });
      }
    }
  };
  socket.onclose = function (e) {
    if (currentReconnectDelay <= 128) {
      console.log(
        'Socket is closed. Reconnect will be attempted in ' + currentReconnectDelay + ' second(s).',
        e.reason
      );
      setTimeout(function () {
        connectWs(currentReconnectDelay * 2);
      }, currentReconnectDelay * 1000);
    } else {
      console.log('Socket is closed. Giving up.');
    }
  };
}

if (typeof ws_personal_url !== 'undefined') {
  connectWs(2);
}

// Clicking on env label should hide it for 5 sec.
$(document).on('click', '#env_indicator_badge', (evt) => {
  const envIndicators = $('.env_indicator');
  envIndicators.fadeOut(() => {
    setTimeout(() => {
      envIndicators.fadeIn();
    }, 500000);
  });
});

// Tester fix

function getCountriesRequireVerification() {
  const countries = document.getElementById('countries_require_verification');

  if (countries) {
    return JSON.parse(countries.textContent);
  }

  return [];
}

$(document).on('submit', 'form.preview-mode', function (e) {
  e.preventDefault();
  $('#preview-alert').show();
  alert('This action is disabled in preview mode.');
});

$(document).on('click', '.btn-book', function (e) {
  e.preventDefault();
  try {
    if (getCountriesRequireVerification().includes(initialCountry)) {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number',
        initialCountry: initialCountry,
        onlyCountries: [initialCountry],
        //excludeCountries: ["us"]
        preferredCountries: []
      });
    } else {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number',
        initialCountry: initialCountry
      });
    }
  } catch (err) {
    if (err.message.startsWith('No country data for')) {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number'
      });
    } else {
      throw err;
    }
  }

  if (initialPhoneNumber !== '') {
    $('#phone_number_helper').intlTelInput('setNumber', initialPhoneNumber);
  }

  $('#confirm-booking-modal [name=from_date]').val($(e.target).data('from_date'));
  $('#confirm-booking-modal [name=to_date]').val($(e.target).data('to_date'));

  $('#confirm-booking-modal #day').html($(e.target).data('day'));
  $('#confirm-booking-modal #from_date').html($(e.target).data('from_time'));
  $('#confirm-booking-modal #to_date').html($(e.target).data('to_time'));

  showModal('confirm-booking-modal');
  return false;
});

$(document).on('hidden.bs.modal', '#sms-verify-booking-modal', function (e) {
  $(this).removeData();
  clearInterval(timerInterval);
  $(this).find('form').trigger('reset');
});

$(document).on('shown.bs.modal', '#sms-verify-booking-modal', function (e) {
  $('#code_first_pin').get(0).focus();
});

$(document).on('shown.bs.modal', '#confirm-booking-modal', function (e) {
  const phoneNumberHelper = $('#phone_number_helper').get(0);
  if (phoneNumberHelper) {
    phoneNumberHelper.focus();
  }
});

$(document).on('hidden.bs.modal', '#confirm-booking-modal', function (e) {
  $('#book-session-before-verify').prop('disabled', false);
  $('#book-session-before-verify').html('Confirm');
  var elements = document.getElementById('book-session-before-verify');
  if (elements) {
    elements.classList.remove('btn__beforeverify');
  }
  $(this).removeData();
  $(this).find('form').trigger('reset');
  $('#warning-text').text('');
});

$(document).on('change', "input[name='consent']", function () {
  //this io ensure the consent button validation
  var elements = document.getElementById('book-session-before-verify');
  var $phoneNumberHelper = $('#phone_number_helper');
  if (!elements || !$phoneNumberHelper.length) return; // different page

  var tester_phone_country_details = $phoneNumberHelper.intlTelInput('getSelectedCountryData');
  var tester_phone_number = $phoneNumberHelper.intlTelInput('getNumber');

  if (this.checked) {
    if (getCountriesRequireVerification().includes(tester_phone_country_details['iso2'].toUpperCase())) {
      if (tester_phone_number != verifiedPhoneNumber) {
        $('#confirm-booking').attr('action', '');
        elements.classList.add('btn__beforeverify');
      }
    }
  } else {
    elements.classList.remove('btn__beforeverify');
  }
});

$(document).on('click', '.btn-book', function (e) {
  e.preventDefault();
  try {
    if (getCountriesRequireVerification().includes(initialCountry)) {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number',
        initialCountry: initialCountry,
        onlyCountries: [initialCountry]
      });
    } else {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number',
        initialCountry: initialCountry
      });
    }
  } catch (err) {
    if (err.message.startsWith('No country data for')) {
      $('#phone_number_helper').intlTelInput({
        nationalMode: true,
        utilsScript: utilsScriptUrl,
        hiddenInput: 'phone_number'
      });
    } else {
      throw err;
    }
  }

  if (initialPhoneNumber !== '') {
    $('#phone_number_helper').intlTelInput('setNumber', initialPhoneNumber);
  }

  $('#confirm-booking-modal [name=from_date]').val($(e.target).data('from_date'));
  $('#confirm-booking-modal [name=to_date]').val($(e.target).data('to_date'));

  $('#confirm-booking-modal #day').html($(e.target).data('day'));
  $('#confirm-booking-modal #from_date').html($(e.target).data('from_time'));
  $('#confirm-booking-modal #to_date').html($(e.target).data('to_time'));

  showModal('confirm-booking-modal');
  return false;
});

$(document).on('click', '.btn__beforeverify', function (e) {
  e.preventDefault();
  if ($('#confirm-booking').hasClass('preview-mode')) {
    alert('This action is disabled in preview mode.');
    return false;
  }

  $('#book-session-before-verify').prop('disabled', true);
  $('#book-session-before-verify').html('Processing');

  var from_date = $('#formatted_from_date').attr('value');
  var to_date = $('#formatted_to_date').attr('value');

  var tester_phone_number = $('#phone_number_helper').intlTelInput('getNumber');
  $('#tester_phone_number_helper').html(tester_phone_number);

  var twoMinutes = 120;
  var display = $('#time');

  const requestVerifyStatus = requestVerification(
    tester_phone_number,
    sendVerificationCodeUrl,
    display,
    twoMinutes,
    false
  );
  if (requestVerifyStatus == false) {
    $('#book-session-before-verify').prop('disabled', false);
    $('#book-session-before-verify').html('Confirm');
  }

  $('#sms-verify-booking-modal [name=phone_number]').attr('value', tester_phone_number);
  $('#sms-verify-booking-modal [name=from_date]').attr('value', from_date);
  $('#sms-verify-booking-modal [name=to_date]').attr('value', to_date);
  $('#sms-verify-booking-modal [name=consent]').attr('value', true);
});

$(document).on('input', '#phone_number_helper', function (e) {
  e.preventDefault();
  var elements = document.getElementById('book-session-before-verify');
  var tester_phone_number = $('#phone_number_helper').intlTelInput('getNumber');
  if (tester_phone_number == verifiedPhoneNumber) {
    var confirm_booking_action = $('#confirm-booking').attr('action');
    if (confirm_booking_action == '') {
      $('#confirm-booking').attr('action', sendBookingConfirmationUrl);
      elements.classList.remove('btn__beforeverify');
    }
  }
});

$(document).on('click', '.btn__verifypin', function (e) {
  e.preventDefault();

  $('#book-session').prop('disabled', true);
  $('#book-session').html('Processing');

  var tester_phone_number = $('#tester_phone_number_helper').text();
  var verify_pin = '';
  $('input[id^=code]').each(function (index) {
    verify_pin = verify_pin + $(this).val();
    $(this).prop('disabled', true);
  }); // to add checking

  $.ajax({
    type: 'POST',
    url: verifyVerificationCodeUrl,
    data: { phone_number: tester_phone_number, verify_pin: verify_pin },
    headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
    success: function (data) {
      if (data.status === 'success') {
        $('#sms-verification').trigger('submit');
        $('#sms-verify-booking-modal').modal('hide');
      } else {
        var elements = document.getElementsByClassName('pin-box');
        [].forEach.call(elements, function (el) {
          el.classList.remove('box');
          el.classList.remove('selected');
          el.classList.add('incorrect');
        });
        $('.warning-verify').text('The code is incorrect. Please try again');
        $('#book-session').prop('disabled', false);
        $('#book-session').html('Confirm');
        $('input[id^=code]').each(function (index) {
          $(this).prop('disabled', false);
        });
      }
    },
    error: function (data) {
      $('.warning-verify').text('Unexpected error occurred. Please try again');
    }
  });
});

$(document).on('click', '.btn__back-sms-confirm', function (e) {
  e.preventDefault();
  var tester_phone_number = $('#tester_phone_number_helper').text();
  $('#sms-verify-booking-modal').modal('hide');
  showModal('confirm-booking-modal');
  $('#phone_number_helper').intlTelInput('setNumber', tester_phone_number);
  $('.warning-verify').text('');
});

$(document).on('click', '#resend-code', function (e) {
  e.preventDefault();
  var display = $('#time');
  var twoMinutes = 120;
  var tester_phone_number = $('#tester_phone_number_helper').text();
  requestVerification(tester_phone_number, sendVerificationCodeUrl, display, twoMinutes, true);
});

$(document).on('input', '.pin-box', function (e) {
  e.preventDefault();
  var input = $(this).val();
  var name = $(this).attr('name');
  var elements = document.getElementsByClassName('pin-box');
  [].forEach.call(elements, function (el) {
    el.classList.remove('box');
    el.classList.remove('incorrect');
    el.classList.add('selected');
  });

  var verify_pin = '';
  $('input[id^=code]').each(function (index) {
    verify_pin = verify_pin + $(this).val();
  });

  $('#sms-verify-booking-modal [name=verify_pin]').attr('value', verify_pin);
});

$(document).on('keyup', '.pin-box', function (e) {
  // backspace and delete key
  if (event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 37) {
    $(this).next('.pin-box').focus();
    if ($(this).attr('id') === 'code_fourth_pin') {
      $('#book-session').focus();
    }
  } else if (event.keyCode == 37) {
    //back arrow key
    if ($(this).attr('id') !== 'code_first_pin') {
      $(this).prev('.pin-box').focus();
    }
  }
  e.preventDefault();
});

$(document).on('submit', '#confirm-booking-modal form', function (e) {
  $('#book-session-before-verify').prop('disabled', true);
  $('#book-session-before-verify').html('Processing');
});

$(document).on('click', '#moderator', function (e) {
  e.preventDefault();
  var current_moderator = $(this).data('moderator_name');
  var moderator_profileimage = $(this).data('moderator_profileimage');
  var practitioner_id = $(this).data('practitioner_id');
  var from_datetime = $(this).data('from_datetime');
  var from_date = $(this).data('from_date');
  var to_date = $(this).data('to_date');

  $('#dropdown-text').text('Select');
  $('#warning-text').text('');
  $('#reassign').attr('action', practitioner_id);
  $('#current_moderator span').text(current_moderator);
  $('#current_moderator_image').attr('src', moderator_profileimage);
  $('#session-from-date').text(from_datetime);
  $('#reassign-moderator-modal [name=from_date]').attr('value', from_date);
  $('#reassign-moderator-modal [name=to_date]').attr('value', to_date);
  $('.btn__testerconfirm').prop('disabled', true);

  showModal('reassign-moderator-modal');
  return false;
});

$(document).on('click', '#moderator-ddd a', function (e) {
  e.preventDefault();
  var current_moderator = $('#current_moderator span').text();
  var selectedModerator_text = $(this).text();
  var selectedModerator_value = $(this).attr('value');
  var target_url = $('#reassign').attr('action');

  $('#dropdown-text').text(selectedModerator_text);
  $('#reassign-moderator-modal [name=moderator]').attr('value', selectedModerator_value);

  $.ajax({
    type: 'POST',
    url: target_url,
    data: { moderator: selectedModerator_value },
    headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
    success: function (data) {
      if (data.error === true) {
        $('#warning-text').text(data.message);
        $('.btn__testerconfirm').prop('disabled', true);
      } else {
        $('#warning-text').text('');
        $('.btn__testerconfirm').prop('disabled', false);
      }
    },
    error: function (data) {
      $('#warning-text').text('Unexpected error occurred. Please try again');
    }
  });

  return false;
});

function startTimer(duration, display) {
  var timer = duration,
    minutes,
    seconds;
  $('#resend-code').prop('disabled', true);

  timerInterval = setInterval(function () {
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    display.text('Resend in ' + minutes + ':' + seconds + ' minutes');

    if (--timer < 0) {
      $('#resend-code').prop('disabled', false);
      display.text('Resend.');
      clearInterval(timerInterval);
    }
  }, 1000);
}

function requestVerification(tester_phone_number, verificationUrl, display, duration, retry) {
  $.ajax({
    type: 'POST',
    url: verificationUrl,
    data: { phone_number: tester_phone_number },
    headers: { 'X-CSRFToken': Cookies.get('csrftoken') },
    success: function (data) {
      if (data.status === 'success') {
        startTimer(duration, display);
        if (!retry) {
          $('#confirm-booking-modal').modal('hide');
          showModal('sms-verify-booking-modal');
        }
      } else {
        if (retry == false) {
          $('#warning-text').text('Failed to send verification code. Please check the number and try again!');
          $('#book-session-before-verify').prop('disabled', false);
          $('#book-session-before-verify').html('Confirm');
        }
      }
    },
    error: function (data) {
      $('#warning-text').text('Unexpected error occurred. Please try again');
    }
  });
}

/**
 * Logout users from insights before engage
 */
$(document).on('click', '#logout-button', function (e) {
  e.preventDefault();
  const refCookie = Cookies.get('REF');
  const followUrl = () => {
    window.location.href = $(this).attr('data-href');
  };
  if (!refCookie) return followUrl();
  buttonLoading({ isLoading: true, button: $(this), spinner: false });
  $.ajax({
    type: 'POST',
    url: '/api/castleguard/logout',
    headers: {
      'X-REFRESH-TOKEN-PAYLOAD': refCookie
    },
    error: function (data) {
      console.error('Error while logging out from insights', data);
    },
    complete: function () {
      followUrl();
    }
  });
});

function setUserTimezone() {
  if (typeof userTimezoneIsUnset !== 'undefined' && typeof userTimezoneSetUrl !== 'undefined' && userTimezoneIsUnset) {
    $.ajax({
      type: 'POST',
      url: userTimezoneSetUrl,
      data: JSON.stringify({
        timezone: guessTz()
      }),
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
        'Content-Type': 'application/json'
      }
    });
  }
}

$(document).ready(function () {
  inputFocusStyleFix();
  initRememberedAlerts();
  setUserTimezone();

  $('body').toggleClass('loading', false); // allow transitions after document is ready
});
